export default __webpack_public_path__ + "static/media/image-birth-control-visit-activity-graphic.1855948a.svg";